import React from "react";
import { Grid, IconButton, Menu, MenuItem, Select, Tab, Tabs, useMediaQuery } from "@mui/material";
import '../../style/graph.css';
import useAuth from "../hooks/useAuth.ts";
import MenuIcon from '@mui/icons-material/Menu';
import { CustomBreakPoint } from "../utils/CustomBreakPoint.tsx";
import ChangePasswordDialog from "./ChangePasswordDialog.tsx";
import CustomSnackbar from '../utils/SnackBarCustomComponent.tsx';

export default function Header ({ entityList, value, handleChange, a11yProps, refs}) {
    const { user, logout, resetPassword, isLocalAuthMode } = useAuth();
    const regexString = /( |\.|@)/g  // This what i have figured but its not working :(
    const [anchorEl, setAnchorEl] = React.useState<any>(null);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = React.useState(false);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarState, setSnackbarState] = React.useState({ label: '', message: '', correct: false });
    const isLargeScreen = useMediaQuery(CustomBreakPoint.breakpoints.down('mlg'));

    const handleLogout = async () => {
        // Implement your logout logic here
        logout();
    };

    const handleChangePassword = (oldPassword: string, newPassword: string) => {
        resetPassword(oldPassword, newPassword)
            .then(() => {
                setSnackbarState({ label: 'correct', message: 'Password aggiornata con successo', correct: true });
                setSnackbarOpen(true);
            })
            .catch((error) => {
                setSnackbarState({
                    label: 'error',
                    message: error?.response?.data?.detail || 'Username o password attuale non validi',
                    correct: false
                });
                setSnackbarOpen(true);
            });
    };

    const handleCapitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const handleMenuClick = (action) => {
        setAnchorEl(null);
        handleChange(null, action)
    };

    return (
        <Grid className='header'
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
        >
            <Grid item xs={1.75} className='rtl-logo-container' sx={{ alignItems:'left' }}>
                <img src={`${process.env.PUBLIC_URL}/images/RTL_logo.svg`} style={{ width: '80%', height: 'auto' }}/>
            </Grid>

            <Grid container item xs>
                <Grid
                    container item
                    direction="column"
                    justifyContent="space-between"
                    alignItems="stretch"
                >
                    <Grid container item className='header-container'>                
                        <Grid item xs={8} md={9} className='title-container' >
                            <span className='title'>{entityList && entityList.length > 0 && `${entityList[value]['title'].toUpperCase()}`}</span>
                        </Grid>
                        
                        <Grid item xs={4} md={3} className='logo-container' sx={{minHeight:'8vw'}} >
                            <img src={`${process.env.PUBLIC_URL}/images/kebula_logo_full_white_r.svg`} style={{ width: '45%', height: 'auto', paddingBlock:'5%' }}/>
                        </Grid>                            

                    </Grid>
                    
                    <Grid container item sx={{justifyContent: "space-between"}}>
                        <Grid container item xs={4} md={1.8} justifyContent='flex-start' alignItems='center' >
                            <span className='hello_tag'>{`Ciao, ${handleCapitalize(user?.name?.split(regexString)[0]) || ''}`}</span>
                        </Grid>

                        <Grid container item xs={6} md={9.4} sx={{ paddingBottom:(!isLargeScreen)?'4px !important': '0', justifyContent:'flex-end', alignItems:'flex-end'}}>
                            {(isLargeScreen) ? (
                                // Mostra menu a tendina quando lo schermo è piccolo
                                entityList && entityList.length > 0 &&
                                <>
                                    <IconButton
                                        aria-label="menu"
                                        onClick={(event) => setAnchorEl(event.currentTarget)}
                                        sx={{ color: 'white'}}
                                    >
                                        <MenuIcon/>
                                    </IconButton>
                                    
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={() => setAnchorEl(null)}
                                        MenuListProps={{
                                            'aria-labelledby': 'menu-button',
                                        }}
                                        PaperProps={{
                                            sx: {
                                                color: 'white',
                                                backgroundColor: 'var(--background-filter)',
                                            },
                                        }}
                                    >
                                        {entityList && entityList.map((tabElement, index) => (
                                            <MenuItem key={'MenuItem' + index} value={index} onClick={() => handleMenuClick(index)}>
                                                {tabElement.label}
                                            </MenuItem>
                                        ))}
                                        {isLocalAuthMode && <MenuItem onClick={() => { setAnchorEl(null); setIsChangePasswordOpen(true); }}>Cambia Password</MenuItem>}
                                        <MenuItem onClick={() => handleLogout()}>Esci</MenuItem>
                                    </Menu>
                                </>
                                ) : (
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="basic tabs example"
                                        TabIndicatorProps={{ style: { overflowY: 'hidden', backgroundColor: 'red' } }}
                                        TabScrollButtonProps={{ sx: { color: 'white' } }}
                                    >
                                        {entityList.map((tabElement, index) => (
                                            <Tab
                                                key={'Tab' + index}
                                                ref={refs.current[index]}
                                                label={tabElement.label}
                                                {...a11yProps(index)}
                                                sx={{
                                                    textTransform: 'none',
                                                    fontFamily: 'Custom_font',
                                                    color: 'white', // Colore del testo delle schede
                                                    '&.Mui-selected': { color: 'white' }, // Colore del testo quando la scheda è selezionata
                                                    display: ['Impostazioni', 'Aiuto'].includes(tabElement.label) ? 'none' : 'flex', // Nascondi le schede non desiderate
                                                }}
                                                className="tab-title"
                                            />
                                        ))}
                                    </Tabs>

                                )
                            }
                            
                        </Grid>

                        {!isLargeScreen &&
                            <Grid container item xs={0.8} sx={{ justifyContent:'flex-end', alignItems:'center'}}>
                                <>
                                    <IconButton
                                        aria-label="menu"
                                        onClick={(event) => setAnchorEl(event.currentTarget)}
                                        sx={{ color: 'white'}}
                                    >
                                        <MenuIcon/>
                                    </IconButton>
                                    
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={() => setAnchorEl(null)}
                                        MenuListProps={{
                                            'aria-labelledby': 'menu-button',
                                        }}
                                        PaperProps={{
                                            sx: {
                                                color: 'white',
                                                backgroundColor: 'var(--background-filter)',
                                            },
                                        }}
                                    >
                                        {entityList.find(el => el.label === 'Impostazioni') && <MenuItem onClick={() => handleMenuClick(entityList.findIndex(el => el.label === 'Impostazioni'))}>Impostazioni</MenuItem>}
                                        {entityList.find(el => el.label === 'Aiuto') && <MenuItem onClick={() => handleMenuClick(entityList.findIndex(el => el.label === 'Aiuto'))}>Aiuto</MenuItem>}
                                        {isLocalAuthMode && <MenuItem onClick={() => { setAnchorEl(null); setIsChangePasswordOpen(true); }}>Cambia Password</MenuItem>}
                                        <MenuItem onClick={() => handleLogout()}>Esci</MenuItem>
                                    </Menu>
                                </>
                            </Grid>
                         }
                    </Grid>
                </Grid>
            </Grid>

            <ChangePasswordDialog
                open={isChangePasswordOpen}
                onClose={() => setIsChangePasswordOpen(false)}
                onSubmit={handleChangePassword}
            />
            <CustomSnackbar open={snackbarOpen} setOpen={setSnackbarOpen} message={snackbarState.message} correct={snackbarState.correct} />
        </Grid>
    )
}